import React from 'react'
import PropTypes from 'prop-types'
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap'

class AssignAdmin extends React.Component {
  static propType = {
    schoolName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      formName: 'assign-confirm',
      isConfirmed: false,
      validation: {},
      isValid: false,
    }
  }

  handleBlur = e => this.validate.element(e.target)

  handleChange = e => {
    if (!e || !e.target || (!e.target.readonly && !e.target.name)) {
      console.error('cannot update state', e)
      return
    }
    const el = e.target
    const elementName = el.name
    const newValue = this.extractValue(el)
    const newState = this.state
    newState[elementName] = newValue
    this.setState(newState, () => {
      if (elementName === 'isConfirmed') {
        this.sendToParent()
      }
    })
  }

  sendToParent = () => {
    const { onSelect } = this.props
    const { isConfirmed } = this.state
    onSelect({
      isConfirmed: isConfirmed,
    })
  }

  validate = {
    element: (el, show = true) => {
      if (!el || !el.name) {
        console.warn('cannot validate element', el)
        return true
      }
      const toValidate = el.name
      const valid = el.checkValidity()
      const v = this.state.validation
      if (show) {
        v[toValidate] = valid
        this.setState({ validation: v })
      }
      return valid
    },

    form: (show = false) => {
      const { formName } = this.state
      let valid = true
      const form = document.getElementsByName(formName)[0]
      const inputs = form.querySelectorAll('input, select')
      for (let i = 0; i < inputs.length; i++) {
        if (!this.validate.element(inputs[i], show)) {
          valid = false
          break // short circuit
        }
      }
      return valid
    },

    getClassName: id => {
      switch (this.state.validation[id]) {
        case true:
          return 'is-valid'
        case false:
          return 'is-invalid'
        default:
          return ''
      }
    },
  }

  extractValue = el => {
    if (!el) return null
    const inputType = el.type
    switch (inputType) {
      case 'checkbox':
      case 'radio':
        return el.checked
      default:
        return el.value
    }
  }

  render = () => {
    const labelWidth = 3
    const fieldWidth = 9
    const { email, schoolName } = this.props
    const { formName, isConfirmed } = this.state

    return (
      <Form name={formName} noValidate>
        <h4>Confirm Assignments</h4>
        <hr />
        <FormGroup row>
          <Label sm={labelWidth}>Assigned School</Label>
          <Label sm={fieldWidth}>
            <Input defaultValue={schoolName} readOnly={true} type="text" />
          </Label>
        </FormGroup>
        <FormGroup row>
          <Label sm={labelWidth}>License Administrator</Label>
          <Label sm={fieldWidth}>
            <Input defaultValue={email} readOnly={true} type="text" />
          </Label>
        </FormGroup>
        <Row>
          <Col sm={{ size: fieldWidth, offset: labelWidth }}>
            <p>
              Once you assign this license to the school above, you won’t be
              able to change it. The License Administrator will receive an email
              with information on how to add user(s) and additional License
              Administrators to this product.
            </p>
          </Col>
        </Row>
        <FormGroup row>
          <Label sm={labelWidth}>{/* spacer */}</Label>
          <Label check sm={fieldWidth} style={{ paddingLeft: '2rem' }}>
            <Input
              aria-required="true"
              checked={isConfirmed}
              className={this.validate.getClassName('isConfirmed')}
              name="isConfirmed"
              onChange={this.handleChange}
              required
              type="checkbox"
            />
            I understand that I can’t change the school assigned once I submit
            it.
          </Label>
          <FormFeedback tooltip>Please confirm.</FormFeedback>
        </FormGroup>
      </Form>
    )
  }
}

export default AssignAdmin



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/setupLicense/AssignConfirm.js